import React, { useEffect } from 'react';
import { CircularProgress, Backdrop, Box, Stack } from '@mui/material';
import Logo from '../../components/logo';



export default function Index() {
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    setOpen(true);

  }, []);

  return (
    <Backdrop
      open={true}
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
    >
      <Box  justifyContent="center" my={5}>

        <Logo />
        <Box  justifyContent="center" my={5}        sx={{
          display: 'flex',
          justifyContent: 'center',
          p: 1,
          m: 1,
          borderRadius: 1,
        }} >

        <CircularProgress color="inherit" />
        </Box>

      </Box>

    </Backdrop>
  );
};

